import SearchFilterComponent from "../searchFilter"
interface Props {
    name: string
    onFilters:(nameFilter: string, valueFilter: string)=> void
    dataOption?: string
}

export const SubheaderComponent = ({ name, onFilters, dataOption }: Props) => {

    return (
        <div>
            <section className="flex flex-wrap flex-auto w-full gap-4 mb-6 ">
                <header className="flex items-center grow shrink-0 p-1 w-1/3">
                    <p className="font-semibold font-[Inter] leading-7 not-italic text-[18px] text-[#101828]">{name}</p>
                </header>
                <div className="grow">
                    <SearchFilterComponent onFilter={onFilters} dataOption={dataOption} />
                </div>
            </section>
        </div>
    )
}